/**
 * Every mod kit the base game and its DLC define.
 *
 * GENERATED FILE — do not edit by hand.
 * Written by `scripts/gta/build-vanilla-data.mjs` from the archives of a local
 * GTA V install (build 1.0.3889.0), on 2026-09-10.
 * Regenerate rather than patching: a hand-edit here is invisible until the next
 * game update silently reverts it.
 */

import type { VanillaModkit } from "../types";

export const VANILLA_MODKITS_VERSION = 1;
export const VANILLA_MODKITS_SOURCE = "Local GTA V installation (carcols.meta and carcols.ymt)";
export const VANILLA_MODKITS_GAME_BUILD = "1.0.3889.0";
export const VANILLA_MODKITS_GENERATED = "2026-09-10";

/**
 * `[id, kitName, vehiclesUsingIt]`, ordered by id.
 *
 * The leading number in a kit name is not reliably its id — Rockstar's own files
 * disagree with themselves about that — so the numeric id is canonical and the
 * name is only ever a label. Allocate against the ids; show the names.
 *
 * A handful of names survive as `hash_XXXXXXXX`: the base game stores kit names
 * hashed, and the generator recovers what it can by hashing the naming
 * convention back. An unreadable name still marks its id as taken, which is the
 * part that matters.
 */
export const VANILLA_MODKITS: VanillaModkit[] = [
  [0, "0_default_kit", ["ambulance", "asterope", "bfinjection", "bison3", "blazer", "blazer2", "blazer3", "burrito", "burrito2", "burrito3", "burrito4", "burrito5", "dloader", "double", "dune", "emperor", "emperor2", "emperor3", "fbi", "fbi2", "fq2", "gburrito", "ingot", "lguard", "minivan", "mule2", "police", "police2", "police4", "policet", "pony", "pony2", "pranger", "radi", "rancherxl2", "regina", "romero", "rumpo2", "sadler2", "sheriff", "sheriff2", "speedo", "speedo2", "stratum", "stretch", "surfer", "surfer2", "taxi", "tornado3", "tornado4", "towtruck2", "trflat", "washington"]],
  [1, "hash_8C6907AE", ["dilettante", "dilettante2"]],
  [2, "hash_EF3C0E60", ["adder", "bullet", "jb700", "stinger", "stingergt", "superd"]],
  [3, "hash_9041F1BE", ["cogcabrio", "exemplar", "f620", "oracle"]],
  [4, "hash_691FB4B8", ["baller2", "bison", "bison2", "bobcatxl", "cavalcade2", "granger", "mesa", "mesa3", "patriot", "rancherxl", "rebel2", "rocoto", "sadler", "seminole"]],
  [5, "hash_5EDA9F61", ["felon2", "gauntlet", "monroe"]],
  [6, "hash_E0E19F06", ["fugitive", "habanero", "picador", "stanier", "voodoo2"]],
  [7, "hash_C6BB5F17", ["bati", "carbonrs", "faggio2", "hexer", "nemesis", "vader"]],
  [8, "1_dubsta_modkit", ["dubsta"]],
  [9, "2_futo_modkit", ["futo"]],
  [10, "3_feltzer2_modkit", ["feltzer2"]],
  [11, "4_akuma_modkit", ["akuma"]],
  [12, "5_tailgater_modkit", ["tailgater"]],
  [13, "6_buffalo_modkit", ["buffalo"]],
  [14, "7_bodhi2_modkit", ["bodhi2"]],
  [15, "8_cavalcade_modkit", ["cavalcade"]],
  [16, "9_police3_modkit", ["police3"]],
  [17, "hash_8DD9D493", ["ruffian"]],
  [18, "11_ninef2_modkit", ["ninef2"]],
  [19, "12_daemon_modkit", ["daemon"]],
  [20, "13_ztype_modkit", ["ztype"]],
  [21, "14_double_modkit", ["double"]],
  [22, "15_baller_modkit", ["baller"]],
  [23, "16_youga_modkit", ["youga"]],
  [24, "17_asea_modkit", ["asea"]],
  [25, "18_buccaneer_modkit", ["buccaneer"]],
  [26, "19_surge_modkit", ["surge"]],
  [27, "20_ratloader_modkit", ["ratloader"]],
  [28, "21_surano_modkit", ["surano"]],
  [29, "22_jackal_modkit", ["jackal"]],
  [30, "23_dubsta2_modkit", ["dubsta2"]],
  [31, "24_phoenix_modkit", ["phoenix"]],
  [32, "26_ninef_modkit", ["ninef"]],
  [33, "27_dominator_modkit", ["dominator"]],
  [34, "28_felon_modkit", ["felon"]],
  [35, "29_penumbra_modkit", ["penumbra"]],
  [36, "30_blista_modkit", ["blista"]],
  [37, "31_elegy2_modkit", ["elegy2"]],
  [38, "32_voltic_modkit", ["voltic"]],
  [39, "33_gresley_modkit", ["gresley"]],
  [40, "34_issi2_modkit", ["issi2"]],
  [41, "35_bjxl_modkit", ["bjxl"]],
  [42, "36_landstalker_modkit", ["landstalker"]],
  [43, "37_premier_modkit", ["premier"]],
  [44, "38_ruiner_modkit", ["ruiner"]],
  [45, "39_sultan_modkit", ["sultan"]],
  [46, "40_serrano_modkit", ["serrano"]],
  [47, "42_pcj_modkit", ["pcj"]],
  [48, "43_rebel_modkit", ["rebel"]],
  [49, "44_fusilade_modkit", ["fusilade"]],
  [50, "45_sentinel_modkit", ["sentinel"]],
  [51, "46_banshee_modkit", ["banshee"]],
  [52, "47_schafter2_modkit", ["schafter2"]],
  [53, "48_khamelion_modkit", ["khamelion"]],
  [54, "49_primo_modkit", ["primo"]],
  [55, "50_prairie_modkit", ["prairie"]],
  [56, "51_comet2_modkit", ["comet2"]],
  [57, "52_vigero_modkit", ["vigero"]],
  [58, "53_schwarzer_modkit", ["schwarzer"]],
  [59, "54_sandking_modkit", ["sandking"]],
  [60, "55_sandking2_modkit", ["sandking2"]],
  [61, "56_sentinel2_modkit", ["sentinel2"]],
  [62, "57_hotknife_modkit", ["hotknife"]],
  [63, "58_bagger_modkit", ["bagger"]],
  [64, "59_manana_modkit", ["manana"]],
  [65, "60_tornado_modkit", ["tornado", "tornado2"]],
  [66, "61_buffalo2_modkit", ["buffalo2"]],
  [67, "62_peyote_modkit", ["peyote"]],
  [68, "63_entityxf_modkit", ["entityxf"]],
  [69, "64_coquette_modkit", ["coquette"]],
  [70, "66_cheetah_modkit", ["cheetah"]],
  [71, "67_sabregt_modkit", ["sabregt"]],
  [72, "68_oracle2_modkit", ["oracle2"]],
  [73, "69_zion_modkit", ["zion"]],
  [74, "70_zion2_modkit", ["zion2"]],
  [75, "71_intruder_modkit", ["intruder"]],
  [76, "72_carbonizzare_modkit", ["carbonizzare"]],
  [77, "73_rapidgt_modkit", ["rapidgt"]],
  [78, "74_vacca_modkit", ["vacca"]],
  [79, "75_infernus_modkit", ["infernus"]],
  [80, "76_rapidgt2_modkit", ["rapidgt2"]],
  [81, "77_bati2_modkit", ["bati2"]],
  [82, "78_sanchez_modkit", ["sanchez", "sanchez2"]],
  [83, "79_stunt_modkit", ["stunt"]],
  [84, "80_shamal_modkit", ["shamal"]],
  [85, "81_rumpo_modkit", ["rumpo"]],
  [86, "82_polmav_modkit", ["polmav"]],
  [87, "83_bifta_modkit", ["bifta"]],
  [88, "84_kalahari_modkit", ["kalahari"]],
  [89, "85_paradise_modkit", ["paradise"]],
  [90, "89_zentorno_modkit", ["zentorno"]],
  [91, "87_massacaro_modkit", ["massacro"]],
  [92, "86_jester_modkit", ["jester"]],
  [93, "88_turismor_modkit", ["turismor"]],
  [94, "90_huntley_modkit", ["huntley"]],
  [95, "91_alpha_modkit", ["alpha"]],
  [96, "96_thrust_modkit", ["thrust"]],
  [97, "97_rhapsody_modkit", ["rhapsody"]],
  [98, "98_warrener_modkit", ["warrener"]],
  [99, "99_blade_modkit", ["blade"]],
  [100, "100_glendale_modkit", ["glendale"]],
  [101, "260_rapidgt3_modkit", ["rapidgt3"]],
  [102, "102_panto_modkit", ["panto"]],
  [103, "103_dubsta3_modkit", ["dubsta3"]],
  [104, "104_pigalle_modkit", ["pigalle"]],
  [105, "105_coquette2_modkit", ["coquette2"]],
  [106, "106_swift_modkit", ["swift", "swift2"]],
  [107, "107_gburrito2_modkit", ["gburrito2"]],
  [108, "108_guardian_modkit", ["guardian"]],
  [109, "109_enduro_modkit", ["enduro"]],
  [110, "110_kuruma_modkit", ["kuruma", "kuruma2"]],
  [111, "111_visione_modkit", ["visione"]],
  [112, "112_voodoo_modkit", ["voodoo"]],
  [113, "113_tornado5_modkit", ["tornado5"]],
  [114, "114_primo2_modkit", ["primo2"]],
  [115, "115_moonbeam2_modkit", ["moonbeam2"]],
  [116, "116_lurcher_modkit", ["lurcher"]],
  [117, "117_chino2_modkit", ["chino2"]],
  [118, "118_btype2_modkit", ["btype2"]],
  [119, "119_virgo2_modkit", ["virgo2"]],
  [120, "120_vigilante_modkit", ["vigilante"]],
  [121, "121_verlierer2_modkit", ["verlierer2"]],
  [122, "122_nightshade_modkit", ["nightshade"]],
  [123, "123_schafter3_modkit", ["schafter3"]],
  [124, "124_schafter4_modkit", ["schafter4"]],
  [125, "125_mamba_modkit", ["mamba"]],
  [126, "126_schafter5_modkit", ["schafter5"]],
  [127, "127_schafter6_modkit", ["schafter6"]],
  [128, "25_tampa_modkit", ["tampa"]],
  [129, "129_howard_modkit", ["howard"]],
  [130, "130_sultanrs_modkit", ["sultanrs"]],
  [131, "131_banshee2_modkit", ["banshee2"]],
  [132, "132_minivan2_modkit", ["minivan2"]],
  [133, "133_bestia_modkit", ["bestiagts"]],
  [134, "134_811_modkit", ["pfister811"]],
  [135, "135_prototipo_modkit", ["prototipo"]],
  [136, "136_windsor2_modkit", ["windsor2"]],
  [137, "137_seven70_modkit", ["seven70"]],
  [138, "138_fmj_modkit", ["fmj"]],
  [139, "139_reaper_modkit", ["reaper"]],
  [140, "140_brioso_modkit", ["brioso"]],
  [141, "141_omnis_modkit", ["omnis"]],
  [142, "142_lynx_modkit", ["lynx"]],
  [143, "143_tampa2_modkit", ["tampa2"]],
  [144, "144_trophytruck_modkit", ["trophytruck"]],
  [145, "145_tropos_modkit", ["tropos"]],
  [146, "146_tyrus_modkit", ["tyrus"]],
  [147, "147_faction3_modkit", ["faction3"]],
  [148, "148_btype3_modkit", ["btype3"]],
  [149, "149_marshall_modkit", ["marshall"]],
  [150, "150_buffalo3_modkit", ["buffalo3"]],
  [151, "151_dominator2_modkit", ["dominator2"]],
  [152, "152_dukes_modkit", ["dukes"]],
  [153, "153_buccaneer_modkit", ["buccaneer2"]],
  [154, "154_blista2_modkit", ["blista2"]],
  [155, "155_blista3_modkit", ["blista3"]],
  [156, "156_jester2_modkit", ["jester2"]],
  [157, "157_massacaro2_modkit", ["massacro2"]],
  [158, "158_ratloader2_modkit", ["ratloader2"]],
  [159, "159_slamvan_modkit", ["slamvan", "slamvan2"]],
  [160, "160_osiris_modkit", ["osiris"]],
  [161, "161_t20_modkit", ["t20"]],
  [162, "162_vindicator_modkit", ["vindicator"]],
  [163, "163_brawler_modkit", ["brawler"]],
  [164, "164_virgo_modkit", ["virgo"]],
  [165, "165_deluxo_modkit", ["deluxo"]],
  [166, "166_coquette3_modkit", ["coquette3"]],
  [167, "167_windsor_modkit", ["windsor"]],
  [168, "168_feltzer3_modkit", ["feltzer3"]],
  [169, "169_savestra_modkit", ["savestra"]],
  [170, "111_faction2_modkit", ["faction2"]],
  [171, "171_slamvan3_modkit", ["slamvan3"]],
  [172, "172_sab2_modkit", ["sabregt2"]],
  [173, "173_gargoyle_modkit", ["gargoyle"]],
  [174, "174_bf400_modkit", ["bf400"]],
  [175, "175_cliffhanger_modkit", ["cliffhanger"]],
  [176, "176_trophytruck2_modkit", ["trophytruck2"]],
  [177, "177_rallytruck_modkit", ["rallytruck"]],
  [178, "178_le7b_modkit", ["le7b"]],
  [179, "179_sheava_modkit", ["sheava"]],
  [180, "180_zombiea_modkit", ["zombiea"]],
  [181, "181_zombieb_modkit", ["zombieb"]],
  [182, "182_avarus_modkit", ["avarus"]],
  [183, "183_defiler_modkit", ["defiler"]],
  [185, "185_nightblade_modkit", ["nightblade"]],
  [186, "186_daemon2_modkit", ["daemon2"]],
  [187, "187_ratbike_modkit", ["ratbike"]],
  [188, "188_chimera_modkit", ["chimera"]],
  [189, "189_wolfsbane_modkit", ["wolfsbane"]],
  [190, "190_vortex_modkit", ["vortex"]],
  [191, "191_hakuchou2_modkit", ["hakuchou2"]],
  [192, "192_blazer4_modkit", ["blazer4"]],
  [193, "193_manchez_modkit", ["manchez"]],
  [194, "194_sanctus_modkit", ["sanctus"]],
  [195, "195_esskey_modkit", ["esskey"]],
  [196, "196_tornado6_modkit", ["tornado6"]],
  [197, "197_faggio3_modkit", ["faggio3"]],
  [198, "198_youga2_modkit", ["youga2"]],
  [199, "199_shotaro_modkit", ["shotaro"]],
  [201, "165_chino_modkit", ["chino"]],
  [202, "202_fcr_modkit", ["fcr"]],
  [204, "204_fcr2_modkit", ["fcr2"]],
  [205, "205_penetrator_modkit", ["penetrator"]],
  [206, "206_nero_modkit", ["nero"]],
  [207, "207_italigtb_modkit", ["italigtb"]],
  [208, "208_italigtb2_modkit", ["italigtb2"]],
  [209, "209_diablous2_modkit", ["diablous2"]],
  [210, "210_tempesta_modkit", ["tempesta"]],
  [211, "211_elegy1_modkit", ["elegy"]],
  [212, "212_nero2_modkit", ["nero2"]],
  [213, "213_comet3_modkit", ["comet3"]],
  [214, "214_specter2_modkit", ["specter2"]],
  [215, "215_voltic2_modkit", ["voltic2"]],
  [216, "216_specter_modkit", ["specter"]],
  [217, "217_ruston_modkit", ["ruston"]],
  [218, "218_cheetah2_modkit", ["cheetah2"]],
  [219, "219_tampa3_modkit", ["tampa3"]],
  [220, "220_ardent_modkit", ["ardent"]],
  [221, "221_infernus2_modkit", ["infernus2"]],
  [222, "222_insurgent3_modkit", ["insurgent3"]],
  [223, "223_gp1_modkit", ["gp1"]],
  [224, "224_torero_modkit", ["torero"]],
  [225, "225_turismo2_modkit", ["turismo2"]],
  [226, "226_apc_modkit", ["apc"]],
  [227, "227_halftrack_modkit", ["halftrack"]],
  [228, "228_dune3_modkit", ["dune3"]],
  [229, "231_chernobog_modkit", ["chernobog"]],
  [230, "230_technical3_modkit", ["technical3"]],
  [232, "232_oppressor_modkit", ["oppressor"]],
  [233, "233_trsmall2_modkit", ["trailersmall2"]],
  [234, "234_trailerlarge_modkit", ["trailerlarge"]],
  [235, "235_nightshark_modkit", ["nightshark"]],
  [236, "236_vagner_modkit", ["vagner"]],
  [237, "237_xa21_modkit", ["xa21"]],
  [238, "238_havok_modkit", ["havok"]],
  [239, "239_rogue_modkit", ["rogue"]],
  [240, "240_mogul_modkit", ["mogul"]],
  [241, "241_starling_modkit", ["starling"]],
  [242, "242_alphaz1_modkit", ["alphaz1"]],
  [243, "243_bombushka_modkit", ["bombushka"]],
  [244, "244_tula_modkit", ["tula"]],
  [245, "245_seabreeze_modkit", ["seabreeze"]],
  [246, "246_pyro_modkit", ["pyro"]],
  [247, "247_hunter_modkit", ["hunter"]],
  [248, "248_nokota_modkit", ["nokota"]],
  [249, "249_molotok_modkit", ["molotok"]],
  [250, "hash_FB9CAE4A", ["annihilator", "buzzard", "cargobob", "cargobob2", "duster", "frogger", "lazer", "luxor", "mammatus", "maverick", "titan", "velum"]],
  [251, "251_cuban800_modkit", ["cuban800"]],
  [252, "252_retinue_modkit", ["retinue"]],
  [253, "253_microlight_modkit", ["microlight"]],
  [254, "254_cyclone_modkit", ["cyclone"]],
  [256, "256_akula_modkit", ["akula"]],
  [257, "257_avenger_modkit", ["avenger", "avenger2"]],
  [258, "258_yosemite_modkit", ["yosemite"]],
  [259, "259_riot2_modkit", ["riot2"]],
  [260, "260_thruster_modkit", ["thruster"]],
  [261, "261_neon_modkit", ["neon"]],
  [262, "262_comet4_modkit", ["comet4"]],
  [263, "263_barrage_modkit", ["barrage"]],
  [264, "264_gt500_modkit", ["gt500"]],
  [265, "265_khanjali_modkit", ["khanjali"]],
  [266, "266_sentinel3_modkit", ["sentinel3"]],
  [267, "267_streiter_modkit", ["streiter"]],
  [268, "268_hermes_modkit", ["hermes"]],
  [269, "269_revolter_modkit", ["revolter"]],
  [270, "270_autarch_modkit", ["autarch"]],
  [272, "272_hustler_modkit", ["hustler"]],
  [273, "273_riata_modkit", ["riata"]],
  [274, "274_pariah_modkit", ["pariah"]],
  [276, "276_z190_modkit", ["z190"]],
  [277, "277_sc1_modkit", ["sc1"]],
  [278, "278_viseris_modkit", ["viseris"]],
  [279, "279_comet5_modkit", ["comet5"]],
  [280, "280_raiden_modkit", ["raiden"]],
  [281, "281_volatol_modkit", ["volatol"]],
  [282, "282_kamacho_modkit", ["kamacho"]],
  [283, "283_gb200_modkit", ["gb200"]],
  [284, "284_fagaloa_modkit", ["fagaloa"]],
  [285, "285_michelli_modkit", ["michelli"]],
  [286, "286_ellie_modkit", ["ellie"]],
  [287, "287_issi3_modkit", ["issi3"]],
  [290, "290_hotring_modkit", ["hotring"]],
  [291, "291_tezeract_modkit", ["tezeract"]],
  [292, "292_caracara_modkit", ["caracara"]],
  [293, "293_flashgt_modkit", ["flashgt"]],
  [294, "294_cheburek_modkit", ["cheburek"]],
  [295, "295_seasparrow_modkit", ["seasparrow"]],
  [296, "296_dominator3_modkit", ["dominator3"]],
  [297, "297_tyrant_modkit", ["tyrant"]],
  [298, "298_taipan_modkit", ["taipan"]],
  [299, "299_entity2_modkit", ["entity2"]],
  [300, "300_jester3_modkit", ["jester3"]],
  [301, "301_pounder2_modkit", ["pounder2"]],
  [302, "302_mule4_modkit", ["mule4"]],
  [303, "303_speedo4_modkit", ["speedo4"]],
  [304, "304_blimp3_modkit", ["blimp3"]],
  [305, "305_swinger_modkit", ["swinger"]],
  [306, "306_patriot2_modkit", ["patriot2"]],
  [307, "307_menacer_modkit", ["menacer"]],
  [308, "308_strikeforce_modkit", ["strikeforce"]],
  [309, "309_oppressor2_modkit", ["oppressor2"]],
  [310, "310_stafford_modkit", ["stafford"]],
  [311, "311_freecrawler_modkit", ["freecrawler"]],
  [312, "312_patriot_modkit", ["patriot"]],
  [313, "313_pbus2_modkit", ["pbus2"]],
  [314, "314_scramjet_modkit", ["scramjet"]],
  [315, "315_impaler_modkit", ["impaler"]],
  [316, "316_deveste_modkit", ["deveste"]],
  [317, "317_clique_modkit", ["clique"]],
  [318, "318_scarab_modkit", ["scarab"]],
  [319, "319_toros_modkit", ["toros"]],
  [320, "320_schlagen_modkit", ["schlagen"]],
  [321, "321_deviant_modkit", ["deviant"]],
  [322, "322_vamos_modkit", ["vamos"]],
  [324, "324_tulip_modkit", ["tulip"]],
  [325, "325_impaler2_modkit", ["impaler2"]],
  [326, "326_dominator4_modkit", ["dominator4"]],
  [327, "327_italigto_modkit", ["italigto"]],
  [328, "328_imperator_modkit", ["imperator"]],
  [329, "329_bruiser_modkit", ["bruiser"]],
  [330, "330_cerberus_modkit", ["cerberus"]],
  [331, "331_deathbike_modkit", ["deathbike"]],
  [332, "332_issi4_modkit", ["issi4"]],
  [334, "334_rcbandito_modkit", ["rcbandito"]],
  [335, "335_zr380_modkit", ["zr380"]],
  [336, "336_slamvan4_modkit", ["slamvan4"]],
  [338, "338_monster3_modkit", ["monster3"]],
  [339, "339_imperator2_modkit", ["imperator2"]],
  [340, "340_brutus_modkit", ["brutus"]],
  [341, "341_dominator5_modkit", ["dominator5"]],
  [342, "342_imperator3_modkit", ["imperator3"]],
  [343, "343_impaler4_modkit", ["impaler4"]],
  [344, "344_deathbike3_modkit", ["deathbike3"]],
  [345, "345_deathbike2_modkit", ["deathbike2"]],
  [346, "346_dominator6_modkit", ["dominator6"]],
  [347, "347_zr3802_modkit", ["zr3802"]],
  [348, "348_cerberus3_modkit", ["cerberus3"]],
  [349, "349_zr3803_modkit", ["zr3803"]],
  [350, "350_issi6_modkit", ["issi6"]],
  [351, "351_cerberus2_modkit", ["cerberus2"]],
  [352, "352_slamvan6_modkit", ["slamvan6"]],
  [353, "353_monster5_modkit", ["monster5"]],
  [354, "354_impaler3_modkit", ["impaler3"]],
  [355, "355_scarab3_modkit", ["scarab3"]],
  [356, "356_brutus3_modkit", ["brutus3"]],
  [357, "357_bruiser3_modkit", ["bruiser3"]],
  [358, "358_slamvan5_modkit", ["slamvan5"]],
  [359, "359_bruiser2_modkit", ["bruiser2"]],
  [360, "360_monster4_modkit", ["monster4"]],
  [361, "361_scarab2_modkit", ["scarab2"]],
  [362, "362_issi5_modkit", ["issi5"]],
  [363, "363_brutus2_modkit", ["brutus2"]],
  [364, "364_zion3_modkit", ["zion3"]],
  [365, "365_hellion_modkit", ["hellion"]],
  [366, "366_thrax_modkit", ["thrax"]],
  [367, "367_issi7_modkit", ["issi7"]],
  [368, "368_locust_modkit", ["locust"]],
  [369, "369_zorrusso_modkit", ["zorrusso"]],
  [370, "370_novak_modkit", ["novak"]],
  [371, "371_Dynasty_modkit", ["dynasty"]],
  [372, "372_nebula_modkit", ["nebula"]],
  [373, "373_drafter_modkit", ["drafter"]],
  [374, "374_gauntlet3_modkit", ["gauntlet3"]],
  [375, "375_caracara2_modkit", ["caracara2"]],
  [376, "376_s80_modkit", ["s80"]],
  [377, "377_gauntlet4_modkit", ["gauntlet4"]],
  [378, "378_krieger_modkit", ["krieger"]],
  [379, "379_neo_modkit", ["neo"]],
  [380, "380_peyote2_modkit", ["peyote2"]],
  [381, "381_emerus_modkit", ["emerus"]],
  [382, "382_rrocket_modkit", ["rrocket"]],
  [383, "383_jugular_modkit", ["jugular"]],
  [384, "384_paragon_modkit", ["paragon", "paragon2"]],
  [385, "385_kanjo_modkit", ["kanjo"]],
  [386, "386_imorgon_modkit", ["imorgon"]],
  [387, "387_asbo_modkit", ["asbo"]],
  [388, "388_rebla_modkit", ["rebla"]],
  [389, "389_komoda_modkit", ["komoda"]],
  [390, "390_Sugoi_modkit", ["sugoi"]],
  [391, "391_manana2_modkit", ["manana2"]],
  [392, "392_polgauntlet_modkit", ["polgauntlet"]],
  [393, "393_polbuffalo_modkit", ["polbuffalo"]],
  [395, "395_polcaracara_modkit", ["polcaracara"]],
  [396, "396_police5_modkit", ["police5"]],
  [400, "400_surfer3_modkit", ["surfer3"]],
  [401, "401_vstr_modkit", ["vstr"]],
  [402, "402_sultan2_modkit", ["sultan2"]],
  [403, "403_zhaba_modkit", ["zhaba"]],
  [404, "404_jb7002_modkit", ["jb7002"]],
  [405, "405_formula_modkit", ["formula"]],
  [406, "406_everon_modkit", ["everon"]],
  [407, "407_outlaw_modkit", ["outlaw"]],
  [408, "408_Stryder_modkit", ["stryder"]],
  [409, "409_minitank_modkit", ["minitank"]],
  [410, "410_retinue2_modkit", ["retinue2"]],
  [411, "411_furia_modkit", ["furia"]],
  [412, "412_vagrant_modkit", ["vagrant"]],
  [413, "413_formula2_modkit", ["formula2"]],
  [414, "414_yosemite2_modkit", ["yosemite2"]],
  [415, "415_dukes3_modkit", ["dukes3"]],
  [418, "418_club_modkit", ["club"]],
  [419, "419_gauntlet5_modkit", ["gauntlet5"]],
  [422, "422_yosemite3_modkit", ["yosemite3"]],
  [423, "423_youga3_modkit", ["youga3"]],
  [424, "424_peyote3_modkit", ["peyote3"]],
  [425, "425_glendale2_modkit", ["glendale2"]],
  [427, "427_polgreenwood_modkit", ["polgreenwood"]],
  [428, "428_penumbra2_modkit", ["penumbra2"]],
  [429, "429_landstalker2_modkit", ["landstalker2"]],
  [430, "430_seminole2_modkit", ["seminole2"]],
  [431, "431_tigon_modkit", ["tigon"]],
  [432, "432_openwheel1_modkit", ["openwheel1"]],
  [433, "433_coquette4_modkit", ["coquette4"]],
  [434, "434_openwheel2_modkit", ["openwheel2"]],
  [436, "436_cargobob5_modkit", ["cargobob5"]],
  [437, "437_seasparrow2_modkit", ["seasparrow2"]],
  [438, "438_manchez2_modkit", ["manchez2"]],
  [439, "439_verus_modkit", ["verus"]],
  [440, "440_brioso2_modkit", ["brioso2"]],
  [442, "442_weevil_modkit", ["weevil"]],
  [443, "443_seasparrow3_modkit", ["seasparrow3"]],
  [444, "444_slamtruck_modkit", ["slamtruck"]],
  [445, "445_kosatka_modkit", ["kosatka"]],
  [446, "446_italirsx_modkit", ["italirsx"]],
  [447, "447_toreador_modkit", ["toreador"]],
  [448, "448_Annihilator2_modkit", ["annihilator2"]],
  [449, "449_squaddie_modkit", ["squaddie"]],
  [450, "450_winky_modkit", ["winky"]],
  [451, "451_veto_modkit", ["veto"]],
  [452, "452_alkonost_modkit", ["alkonost"]],
  [453, "453_veto2_modkit", ["veto2"]],
  [455, "455_ignus_modkit", ["ignus"]],
  [456, "456_jester4_modkit", ["jester4"]],
  [457, "457_calico_modkit", ["calico"]],
  [458, "458_zr350_modkit", ["zr350"]],
  [459, "459_remus_modkit", ["remus"]],
  [460, "460_cypher_modkit", ["cypher"]],
  [461, "461_vectre_modkit", ["vectre"]],
  [462, "462_dominator7_modkit", ["dominator7"]],
  [463, "463_comet6_modkit", ["comet6"]],
  [464, "464_rt3000_modkit", ["rt3000"]],
  [465, "465_warrener2_modkit", ["warrener2"]],
  [466, "466_tailgater2_modkit", ["tailgater2"]],
  [467, "467_sultan3_modkit", ["sultan3"]],
  [468, "468_euros_modkit", ["euros"]],
  [469, "469_dominator8_modkit", ["dominator8"]],
  [470, "470_previon_modkit", ["previon"]],
  [471, "471_futo2_modkit", ["futo2"]],
  [472, "472_growler_modkit", ["growler"]],
  [473, "473_granger2_modkit", ["granger2"]],
  [474, "474_ignus2_modkit", ["ignus2"]],
  [475, "475_deity_modkit", ["deity"]],
  [476, "476_astron_modkit", ["astron"]],
  [478, "478_jubilee_modkit", ["jubilee"]],
  [479, "479_patriot3_modkit", ["patriot3"]],
  [480, "480_cyclone2_modkit", ["cyclone2"]],
  [481, "481_comet7_modkit", ["comet7"]],
  [482, "482_buffalo4_modkit", ["buffalo4"]],
  [483, "483_s95_modkit", ["s95"]],
  [484, "484_zeno_modkit", ["zeno"]],
  [485, "485_baller7_modkit", ["baller7"]],
  [486, "486_arbitergt_modkit", ["arbitergt"]],
  [487, "487_astron2_modkit", ["astron2"]],
  [488, "488_cinquemila_modkit", ["cinquemila"]],
  [489, "489_iwagen_modkit", ["iwagen"]],
  [490, "490_champion_modkit", ["champion"]],
  [491, "491_reever_modkit", ["reever"]],
  [492, "492_shinobi_modkit", ["shinobi"]],
  [493, "493_sm722_modkit", ["sm722"]],
  [494, "494_weevil2_modkit", ["weevil2"]],
  [495, "495_rhinehart_modkit", ["rhinehart"]],
  [496, "496_lm87_modkit", ["lm87"]],
  [497, "497_vigero2_modkit", ["vigero2"]],
  [498, "498_torero2_modkit", ["torero2"]],
  [499, "499_tenf_modkit", ["tenf"]],
  [500, "500_greenwood_modkit", ["greenwood"]],
  [501, "501_postlude_modkit", ["postlude"]],
  [502, "502_kanjosj_modkit", ["kanjosj"]],
  [503, "503_draugur_modkit", ["draugur"]],
  [504, "504_corsita_modkit", ["corsita"]],
  [505, "505_tenf2_modkit", ["tenf2"]],
  [506, "506_brioso3_modkit", ["brioso3"]],
  [507, "507_picador_modkit", ["picador"]],
  [508, "508_ruiner4_modkit", ["ruiner4"]],
  [509, "509_conada_modkit", ["conada"]],
  [510, "510_sentinel4_modkit", ["sentinel4"]],
  [511, "511_omnisegt_modkit", ["omnisegt"]],
  [512, "512_powersurge_modkit", ["powersurge"]],
  [513, "513_eudora_modkit", ["eudora"]],
  [514, "514_journey2_modkit", ["journey2"]],
  [515, "515_manchez3_modkit", ["manchez3"]],
  [516, "516_panthere_modkit", ["panthere"]],
  [517, "517_entity3_modkit", ["entity3"]],
  [518, "518_boor_modkit", ["boor"]],
  [519, "519_virtue_modkit", ["virtue"]],
  [520, "520_everon2_modkit", ["everon2"]],
  [521, "521_r300_modkit", ["r300"]],
  [522, "522_broadway_modkit", ["broadway"]],
  [523, "523_tulip2_modkit", ["tulip2"]],
  [524, "524_brickade2_modkit", ["brickade2"]],
  [525, "525_tahoma_modkit", ["tahoma"]],
  [526, "526_issi8_modkit", ["issi8"]],
  [527, "527_conada2_modkit", ["conada2"]],
  [528, "528_gauntlet6_modkit", ["gauntlet6"]],
  [529, "529_brigham_modkit", ["brigham"]],
  [530, "530_clique2_modkit", ["clique2"]],
  [531, "531_l35_modkit", ["l35"]],
  [532, "532_avenger3_modkit", ["avenger3", "avenger4"]],
  [533, "533_ratel_modkit", ["ratel"]],
  [534, "534_stingertt_modkit", ["stingertt"]],
  [535, "535_coureur_modkit", ["coureur"]],
  [536, "536_streamer216_modkit", ["streamer216"]],
  [538, "538_buffalo5_modkit", ["buffalo5"]],
  [539, "539_raiju_modkit", ["raiju"]],
  [540, "540_speedo5_modkit", ["speedo5"]],
  [541, "541_monstrociti_modkit", ["monstrociti"]],
  [542, "542_turismo3_modkit", ["turismo3"]],
  [543, "543_dominator9_modkit", ["dominator9"]],
  [544, "544_fr36_modkit", ["fr36"]],
  [545, "545_aleutian_modkit", ["aleutian"]],
  [546, "546_cavalcade3_modkit", ["cavalcade3"]],
  [547, "547_vigero3_modkit", ["vigero3"]],
  [548, "548_impaler5_modkit", ["impaler5"]],
  [549, "549_drifteuros_modkit", ["drifteuros"]],
  [550, "550_driftfr36_modkit", ["driftfr36"]],
  [551, "551_driftfuto_modkit", ["driftfuto"]],
  [552, "552_driftjester_modkit", ["driftjester"]],
  [553, "553_driftremus_modkit", ["driftremus"]],
  [554, "554_drifttampa_modkit", ["drifttampa"]],
  [555, "555_driftyosemite_modkit", ["driftyosemite"]],
  [556, "556_driftzr350_modkit", ["driftzr350"]],
  [557, "557_dorado_modkit", ["dorado"]],
  [558, "558_baller8_modkit", ["baller8"]],
  [559, "559_impaler6_modkit", ["impaler6"]],
  [560, "560_asterope2_modkit", ["asterope2"]],
  [561, "561_vivanite_modkit", ["vivanite"]],
  [562, "562_terminus_modkit", ["terminus"]],
  [563, "563_yosemite1500_modkit", ["yosemite1500"]],
  [564, "564_vorschlaghammer_modkit", ["vorschlaghammer"]],
  [565, "565_driftcypher_modkit", ["driftcypher"]],
  [566, "566_driftsentinel_modkit", ["driftsentinel"]],
  [567, "567_driftnebula_modkit", ["driftnebula"]],
  [568, "568_driftvorschlag_modkit", ["driftvorschlag"]],
  [569, "569_polimpaler5_modkit", ["polimpaler5"]],
  [570, "570_polimpaler6_modkit", ["polimpaler6"]],
  [571, "571_dominator10_modkit", ["dominator10"]],
  [572, "572_castigator_modkit", ["castigator"]],
  [573, "573_policet3_modkit", ["policet3"]],
  [574, "574_pipistrello_modkit", ["pipistrello"]],
  [575, "575_envisage_modkit", ["envisage"]],
  [576, "576_poldorado_modkit", ["poldorado"]],
  [578, "578_poldominator10_modkit", ["poldominator10"]],
  [579, "579_eurosX32_modkit", ["eurosx32"]],
  [580, "580_paragon3_modkit", ["paragon3"]],
  [581, "581_coquette5_modkit", ["coquette5"]],
  [582, "582_niobe_modkit", ["niobe"]],
  [583, "583_duster2_modkit", ["duster2"]],
  [584, "584_polterminus_modkit", ["polterminus"]],
  [585, "585_driftfuto2_modkit", ["driftfuto2"]],
  [586, "586_driftcheburek_modkit", ["driftcheburek"]],
  [587, "587_driftjester3_modkit", ["driftjester3"]],
  [588, "588_polcoquette4_modkit", ["polcoquette4"]],
  [589, "589_polfaction2_modkit", ["polfaction2"]],
  [590, "590_jester5_modkit", ["jester5"]],
  [591, "591_terbyte_modkit", ["terbyte"]],
  [592, "592_chavosv6_modkit", ["chavosv6"]],
  [593, "593_titan2_modkit", ["titan2"]],
  [594, "594_uranus_modkit", ["uranus"]],
  [595, "595_banshee3_modkit", ["banshee3"]],
  [596, "596_coquette6_modkit", ["coquette6"]],
  [597, "597_firebolt_modkit", ["firebolt"]],
  [598, "598_policeb2_modkit", ["policeb2"]],
  [599, "599_l352_modkit", ["l352"]],
  [600, "600_driftl352_modkit", ["driftl352"]],
  [601, "601_driftdominator10_modkit", ["driftdominator10"]],
  [602, "602_driftgauntlet4_modkit", ["driftgauntlet4"]],
  [603, "603_driftchavosv6_modkit", ["driftchavosv6"]],
  [604, "604_hardy_modkit", ["hardy"]],
  [605, "605_cheetah3_modkit", ["cheetah3"]],
  [606, "606_sentinel5_modkit", ["sentinel5"]],
  [607, "607_everon3_modkit", ["everon3"]],
  [608, "608_drifthardy_modkit", ["drifthardy"]],
  [609, "609_tampa4_modkit", ["tampa4"]],
  [610, "610_suzume_modkit", ["suzume"]],
  [611, "611_rapidgt4_modkit", ["rapidgt4"]],
  [612, "612_minimus_modkit", ["minimus"]],
  [613, "613_woodlander_modkit", ["woodlander"]],
  [614, "614_driftrt3000_modkit", ["driftrt3000"]],
  [615, "615_keitora_modkit", ["keitora"]],
  [616, "616_driftkeitora_modkit", ["driftkeitora"]],
  [617, "617_driftdominator9_modkit", ["driftdominator9"]],
  [618, "618_driftsentinel2_modkit", ["driftsentinel2"]],
  [619, "619_itali2_modkit", ["itali2"]],
  [620, "620_gt750_modkit", ["gt750"]],
  [621, "621_sentinel6_modkit", ["sentinel6"]],
  [622, "622_xtreme_modkit", ["xtreme"]],
  [623, "623_luiva_modkit", ["luiva"]],
  [624, "624_vivanite2_modkit", ["vivanite2"]],
  [625, "625_polbuffalo6_modkit", ["polbuffalo6"]],
  [626, "626_fmj2_modkit", ["fmj2"]],
  [627, "627_astrale_modkit", ["astrale"]],
  [629, "629_driftcoquette_modkit", ["driftcoquette"]],
  [630, "630_driftelegy_modkit", ["driftelegy"]],
  [631, "631_velenogt_modkit", ["velenogt"]],
  [632, "632_laufer_modkit", ["laufer"]],
  [633, "633_lrcgt_modkit", ["lrcgt"]],
  [634, "634_cartuccia_modkit", ["cartuccia"]],
  [635, "635_horus_modkit", ["horus"]],
  [636, "636_merula_modkit", ["merula"]],
  [637, "637_polignus_modkit", ["polignus"]],
  [638, "638_estride_modkit", ["estride"]],
  [639, "639_caracara3_modkit", ["caracara3"]],
  [640, "640_warden_modkit", ["warden"]],
  [999, "999_placeholderhydraulic_modkit", []],
];

/**
 * Every name a stock kit is known by, including the second name a kit picks up
 * when the base game and a DLC ship it under different spellings — `0_default_kit`
 * and `0_default_modkit` are the same kit, and a mod naming either one means it.
 */
export const VANILLA_MODKIT_NAMES: readonly string[] = [
  "0_default_kit", "0_default_modkit", "100_glendale_modkit", "102_panto_modkit",
  "103_dubsta3_modkit", "104_pigalle_modkit", "105_coquette2_modkit", "106_swift_modkit",
  "107_gburrito2_modkit", "108_guardian_modkit", "109_enduro_modkit", "110_kuruma_modkit",
  "111_faction2_modkit", "111_visione_modkit", "112_voodoo_modkit", "113_tornado5_modkit",
  "114_primo2_modkit", "115_moonbeam2_modkit", "116_lurcher_modkit", "117_chino2_modkit",
  "118_btype2_modkit", "119_virgo2_modkit", "11_ninef2_modkit", "120_vigilante_modkit",
  "121_verlierer2_modkit", "122_nightshade_modkit", "123_schafter3_modkit", "124_schafter4_modkit",
  "125_mamba_modkit", "126_schafter5_modkit", "127_schafter6_modkit", "129_howard_modkit",
  "12_daemon_modkit", "130_sultanrs_modkit", "131_banshee2_modkit", "132_minivan2_modkit",
  "133_bestia_modkit", "134_811_modkit", "135_prototipo_modkit", "136_windsor2_modkit",
  "137_seven70_modkit", "138_fmj_modkit", "139_reaper_modkit", "13_ztype_modkit",
  "140_brioso_modkit", "141_omnis_modkit", "142_lynx_modkit", "143_tampa2_modkit",
  "144_trophytruck_modkit", "145_tropos_modkit", "146_tyrus_modkit", "147_faction3_modkit",
  "148_btype3_modkit", "149_marshall_modkit", "14_double_modkit", "150_buffalo3_modkit",
  "151_dominator2_modkit", "152_dukes_modkit", "153_buccaneer_modkit", "154_blista2_modkit",
  "155_blista3_modkit", "156_jester2_modkit", "157_massacaro2_modkit", "158_ratloader2_modkit",
  "159_slamvan_modkit", "15_baller_modkit", "160_osiris_modkit", "161_t20_modkit",
  "162_vindicator_modkit", "163_brawler_modkit", "164_virgo_modkit", "165_chino_modkit",
  "165_deluxo_modkit", "166_coquette3_modkit", "167_windsor_modkit", "168_feltzer3_modkit",
  "169_savestra_modkit", "16_youga_modkit", "171_slamvan3_modkit", "172_sab2_modkit",
  "173_gargoyle_modkit", "174_bf400_modkit", "175_cliffhanger_modkit", "176_trophytruck2_modkit",
  "177_rallytruck_modkit", "178_le7b_modkit", "179_sheava_modkit", "17_asea_modkit",
  "180_zombiea_modkit", "181_zombieb_modkit", "182_avarus_modkit", "183_defiler_modkit",
  "185_nightblade_modkit", "186_daemon2_modkit", "187_ratbike_modkit", "188_chimera_modkit",
  "189_wolfsbane_modkit", "18_buccaneer_modkit", "190_vortex_modkit", "191_hakuchou2_modkit",
  "192_blazer4_modkit", "193_manchez_modkit", "194_sanctus_modkit", "195_esskey_modkit",
  "196_tornado6_modkit", "197_faggio3_modkit", "198_youga2_modkit", "199_shotaro_modkit",
  "19_surge_modkit", "1_dubsta_modkit", "202_fcr_modkit", "204_fcr2_modkit",
  "205_penetrator_modkit", "206_nero_modkit", "207_italigtb_modkit", "208_italigtb2_modkit",
  "209_diablous2_modkit", "20_ratloader_modkit", "210_tempesta_modkit", "211_elegy1_modkit",
  "212_nero2_modkit", "213_comet3_modkit", "214_specter2_modkit", "215_voltic2_modkit",
  "216_specter_modkit", "217_ruston_modkit", "218_cheetah2_modkit", "219_tampa3_modkit",
  "21_surano_modkit", "220_ardent_modkit", "221_infernus2_modkit", "222_insurgent3_modkit",
  "223_gp1_modkit", "224_torero_modkit", "225_turismo2_modkit", "226_apc_modkit",
  "227_halftrack_modkit", "228_dune3_modkit", "22_jackal_modkit", "230_technical3_modkit",
  "231_chernobog_modkit", "232_oppressor_modkit", "233_trsmall2_modkit", "234_trailerlarge_modkit",
  "235_nightshark_modkit", "236_vagner_modkit", "237_xa21_modkit", "238_havok_modkit",
  "239_rogue_modkit", "23_dubsta2_modkit", "240_mogul_modkit", "241_starling_modkit",
  "242_alphaz1_modkit", "243_bombushka_modkit", "244_tula_modkit", "245_seabreeze_modkit",
  "246_pyro_modkit", "247_hunter_modkit", "248_nokota_modkit", "249_molotok_modkit",
  "24_phoenix_modkit", "251_cuban800_modkit", "252_retinue_modkit", "253_microlight_modkit",
  "254_cyclone_modkit", "256_akula_modkit", "257_avenger_modkit", "258_yosemite_modkit",
  "259_riot2_modkit", "25_tampa_modkit", "260_rapidgt3_modkit", "260_thruster_modkit",
  "261_neon_modkit", "262_comet4_modkit", "263_barrage_modkit", "264_gt500_modkit",
  "265_khanjali_modkit", "266_sentinel3_modkit", "267_streiter_modkit", "268_hermes_modkit",
  "269_revolter_modkit", "26_ninef_modkit", "270_autarch_modkit", "272_hustler_modkit",
  "273_riata_modkit", "274_pariah_modkit", "276_z190_modkit", "277_sc1_modkit",
  "278_viseris_modkit", "279_comet5_modkit", "27_dominator_modkit", "280_raiden_modkit",
  "281_volatol_modkit", "282_kamacho_modkit", "283_gb200_modkit", "284_fagaloa_modkit",
  "285_michelli_modkit", "286_ellie_modkit", "287_issi3_modkit", "28_felon_modkit",
  "290_hotring_modkit", "291_tezeract_modkit", "292_caracara_modkit", "293_flashgt_modkit",
  "294_cheburek_modkit", "295_seasparrow_modkit", "296_dominator3_modkit", "297_tyrant_modkit",
  "298_taipan_modkit", "299_entity2_modkit", "29_penumbra_modkit", "2_futo_modkit",
  "300_jester3_modkit", "301_pounder2_modkit", "302_mule4_modkit", "303_speedo4_modkit",
  "304_blimp3_modkit", "305_swinger_modkit", "306_patriot2_modkit", "307_menacer_modkit",
  "308_strikeforce_modkit", "309_oppressor2_modkit", "30_blista_modkit", "310_stafford_modkit",
  "311_freecrawler_modkit", "312_patriot_modkit", "313_pbus2_modkit", "314_scramjet_modkit",
  "315_impaler_modkit", "316_deveste_modkit", "317_clique_modkit", "318_scarab_modkit",
  "319_toros_modkit", "31_elegy2_modkit", "320_schlagen_modkit", "321_deviant_modkit",
  "322_vamos_modkit", "324_tulip_modkit", "325_impaler2_modkit", "326_dominator4_modkit",
  "327_italigto_modkit", "328_imperator_modkit", "329_bruiser_modkit", "32_voltic_modkit",
  "330_cerberus_modkit", "331_deathbike_modkit", "332_issi4_modkit", "334_rcbandito_modkit",
  "335_zr380_modkit", "336_slamvan4_modkit", "338_monster3_modkit", "339_imperator2_modkit",
  "33_gresley_modkit", "340_brutus_modkit", "341_dominator5_modkit", "342_imperator3_modkit",
  "343_impaler4_modkit", "344_deathbike3_modkit", "345_deathbike2_modkit", "346_dominator6_modkit",
  "347_zr3802_modkit", "348_cerberus3_modkit", "349_zr3803_modkit", "34_issi2_modkit",
  "350_issi6_modkit", "351_cerberus2_modkit", "352_slamvan6_modkit", "353_monster5_modkit",
  "354_impaler3_modkit", "355_scarab3_modkit", "356_brutus3_modkit", "357_bruiser3_modkit",
  "358_slamvan5_modkit", "359_bruiser2_modkit", "35_bjxl_modkit", "360_monster4_modkit",
  "361_scarab2_modkit", "362_issi5_modkit", "363_brutus2_modkit", "364_zion3_modkit",
  "365_hellion_modkit", "366_thrax_modkit", "367_issi7_modkit", "368_locust_modkit",
  "369_zorrusso_modkit", "36_landstalker_modkit", "370_novak_modkit", "371_dynasty_modkit",
  "372_nebula_modkit", "373_drafter_modkit", "374_gauntlet3_modkit", "375_caracara2_modkit",
  "376_s80_modkit", "377_gauntlet4_modkit", "378_krieger_modkit", "379_neo_modkit",
  "37_premier_modkit", "380_peyote2_modkit", "381_emerus_modkit", "382_rrocket_modkit",
  "383_jugular_modkit", "384_paragon_modkit", "385_kanjo_modkit", "386_imorgon_modkit",
  "387_asbo_modkit", "388_rebla_modkit", "389_komoda_modkit", "38_ruiner_modkit",
  "390_sugoi_modkit", "391_manana2_modkit", "392_polgauntlet_modkit", "393_polbuffalo_modkit",
  "395_polcaracara_modkit", "396_police5_modkit", "39_sultan_modkit", "3_feltzer2_modkit",
  "400_surfer3_modkit", "401_vstr_modkit", "402_sultan2_modkit", "403_zhaba_modkit",
  "404_jb7002_modkit", "405_formula_modkit", "406_everon_modkit", "407_outlaw_modkit",
  "408_stryder_modkit", "409_minitank_modkit", "40_serrano_modkit", "410_retinue2_modkit",
  "411_furia_modkit", "412_vagrant_modkit", "413_formula2_modkit", "414_yosemite2_modkit",
  "415_dukes3_modkit", "418_club_modkit", "419_gauntlet5_modkit", "422_yosemite3_modkit",
  "423_youga3_modkit", "424_peyote3_modkit", "425_glendale2_modkit", "427_polgreenwood_modkit",
  "428_penumbra2_modkit", "429_landstalker2_modkit", "42_pcj_modkit", "430_seminole2_modkit",
  "431_tigon_modkit", "432_openwheel1_modkit", "433_coquette4_modkit", "434_openwheel2_modkit",
  "436_cargobob5_modkit", "437_seasparrow2_modkit", "438_manchez2_modkit", "439_verus_modkit",
  "43_rebel_modkit", "440_brioso2_modkit", "442_weevil_modkit", "443_seasparrow3_modkit",
  "444_slamtruck_modkit", "445_kosatka_modkit", "446_italirsx_modkit", "447_toreador_modkit",
  "448_annihilator2_modkit", "449_squaddie_modkit", "44_fusilade_modkit", "450_winky_modkit",
  "451_veto_modkit", "452_alkonost_modkit", "453_veto2_modkit", "455_ignus_modkit",
  "456_jester4_modkit", "457_calico_modkit", "458_zr350_modkit", "459_remus_modkit",
  "45_sentinel_modkit", "460_cypher_modkit", "461_vectre_modkit", "462_dominator7_modkit",
  "463_comet6_modkit", "464_rt3000_modkit", "465_warrener2_modkit", "466_tailgater2_modkit",
  "467_sultan3_modkit", "468_euros_modkit", "469_dominator8_modkit", "46_banshee_modkit",
  "470_previon_modkit", "471_futo2_modkit", "472_growler_modkit", "473_granger2_modkit",
  "474_ignus2_modkit", "475_deity_modkit", "476_astron_modkit", "478_jubilee_modkit",
  "479_patriot3_modkit", "47_schafter2_modkit", "480_cyclone2_modkit", "481_comet7_modkit",
  "482_buffalo4_modkit", "483_s95_modkit", "484_zeno_modkit", "485_baller7_modkit",
  "486_arbitergt_modkit", "487_astron2_modkit", "488_cinquemila_modkit", "489_iwagen_modkit",
  "48_khamelion_modkit", "490_champion_modkit", "491_reever_modkit", "492_shinobi_modkit",
  "493_sm722_modkit", "494_weevil2_modkit", "495_rhinehart_modkit", "496_lm87_modkit",
  "497_vigero2_modkit", "498_torero2_modkit", "499_tenf_modkit", "49_primo_modkit",
  "4_akuma_modkit", "500_greenwood_modkit", "501_postlude_modkit", "502_kanjosj_modkit",
  "503_draugur_modkit", "504_corsita_modkit", "505_tenf2_modkit", "506_brioso3_modkit",
  "507_picador_modkit", "508_ruiner4_modkit", "509_conada_modkit", "50_prairie_modkit",
  "510_sentinel4_modkit", "511_omnisegt_modkit", "512_powersurge_modkit", "513_eudora_modkit",
  "514_journey2_modkit", "515_manchez3_modkit", "516_panthere_modkit", "517_entity3_modkit",
  "518_boor_modkit", "519_virtue_modkit", "51_comet2_modkit", "520_everon2_modkit",
  "521_r300_modkit", "522_broadway_modkit", "523_tulip2_modkit", "524_brickade2_modkit",
  "525_tahoma_modkit", "526_issi8_modkit", "527_conada2_modkit", "528_gauntlet6_modkit",
  "529_brigham_modkit", "52_vigero_modkit", "530_clique2_modkit", "531_l35_modkit",
  "532_avenger3_modkit", "533_ratel_modkit", "534_stingertt_modkit", "535_coureur_modkit",
  "536_streamer216_modkit", "538_buffalo5_modkit", "539_raiju_modkit", "53_schwarzer_modkit",
  "540_speedo5_modkit", "541_monstrociti_modkit", "542_turismo3_modkit", "543_dominator9_modkit",
  "544_fr36_modkit", "545_aleutian_modkit", "546_cavalcade3_modkit", "547_vigero3_modkit",
  "548_impaler5_modkit", "549_drifteuros_modkit", "54_sandking_modkit", "550_driftfr36_modkit",
  "551_driftfuto_modkit", "552_driftjester_modkit", "553_driftremus_modkit", "554_drifttampa_modkit",
  "555_driftyosemite_modkit", "556_driftzr350_modkit", "557_dorado_modkit", "558_baller8_modkit",
  "559_impaler6_modkit", "55_sandking2_modkit", "560_asterope2_modkit", "561_vivanite_modkit",
  "562_terminus_modkit", "563_yosemite1500_modkit", "564_vorschlaghammer_modkit", "565_driftcypher_modkit",
  "566_driftsentinel_modkit", "567_driftnebula_modkit", "568_driftvorschlag_modkit", "569_polimpaler5_modkit",
  "56_sentinel2_modkit", "570_polimpaler6_modkit", "571_dominator10_modkit", "572_castigator_modkit",
  "573_policet3_modkit", "574_pipistrello_modkit", "575_envisage_modkit", "576_poldorado_modkit",
  "578_poldominator10_modkit", "579_eurosx32_modkit", "57_hotknife_modkit", "580_paragon3_modkit",
  "581_coquette5_modkit", "582_niobe_modkit", "583_duster2_modkit", "584_polterminus_modkit",
  "585_driftfuto2_modkit", "586_driftcheburek_modkit", "587_driftjester3_modkit", "588_polcoquette4_modkit",
  "589_polfaction2_modkit", "58_bagger_modkit", "590_jester5_modkit", "591_terbyte_modkit",
  "592_chavosv6_modkit", "593_titan2_modkit", "594_uranus_modkit", "595_banshee3_modkit",
  "596_coquette6_modkit", "597_firebolt_modkit", "598_policeb2_modkit", "599_l352_modkit",
  "59_manana_modkit", "5_tailgater_modkit", "600_driftl352_modkit", "601_driftdominator10_modkit",
  "602_driftgauntlet4_modkit", "603_driftchavosv6_modkit", "604_hardy_modkit", "605_cheetah3_modkit",
  "606_sentinel5_modkit", "607_everon3_modkit", "608_drifthardy_modkit", "609_tampa4_modkit",
  "60_tornado_modkit", "610_suzume_modkit", "611_rapidgt4_modkit", "612_minimus_modkit",
  "613_woodlander_modkit", "614_driftrt3000_modkit", "615_keitora_modkit", "616_driftkeitora_modkit",
  "617_driftdominator9_modkit", "618_driftsentinel2_modkit", "619_itali2_modkit", "61_buffalo2_modkit",
  "620_gt750_modkit", "621_sentinel6_modkit", "622_xtreme_modkit", "623_luiva_modkit",
  "624_vivanite2_modkit", "625_polbuffalo6_modkit", "626_fmj2_modkit", "627_astrale_modkit",
  "629_driftcoquette_modkit", "62_peyote_modkit", "630_driftelegy_modkit", "631_velenogt_modkit",
  "632_laufer_modkit", "633_lrcgt_modkit", "634_cartuccia_modkit", "635_horus_modkit",
  "636_merula_modkit", "637_polignus_modkit", "638_estride_modkit", "639_caracara3_modkit",
  "63_entityxf_modkit", "640_warden_modkit", "64_coquette_modkit", "66_cheetah_modkit",
  "67_sabregt_modkit", "68_oracle2_modkit", "69_zion_modkit", "6_buffalo_modkit",
  "70_zion2_modkit", "71_intruder_modkit", "72_carbonizzare_modkit", "73_rapidgt_modkit",
  "74_vacca_modkit", "75_infernus_modkit", "76_rapidgt2_modkit", "77_bati2_modkit",
  "78_sanchez_modkit", "79_stunt_modkit", "7_bodhi2_modkit", "80_shamal_modkit",
  "81_rumpo_modkit", "82_polmav_modkit", "83_bifta_modkit", "84_kalahari_modkit",
  "85_paradise_modkit", "86_jester_modkit", "87_massacaro_modkit", "88_turismor_modkit",
  "89_zentorno_modkit", "8_cavalcade_modkit", "90_huntley_modkit", "91_alpha_modkit",
  "96_thrust_modkit", "97_rhapsody_modkit", "98_warrener_modkit", "999_placeholderhydraulic_modkit",
  "99_blade_modkit", "9_police3_modkit", "hash_5eda9f61", "hash_691fb4b8",
  "hash_8c6907ae", "hash_8dd9d493", "hash_9041f1be", "hash_c6bb5f17",
  "hash_e0e19f06", "hash_ef3c0e60", "hash_fb9cae4a",
];

/** Siren profile ids (`sirenSettings`) the base game already defines. */
export const VANILLA_SIREN_IDS: readonly number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];

/** Light setting ids (`lightSettings`) the base game already defines. */
export const VANILLA_LIGHT_IDS: readonly number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 198, 202, 205, 206, 207, 210, 211, 212, 213, 214, 215, 216, 217];
